import { render, staticRenderFns } from "./EditGymAscentBtn.vue?vue&type=template&id=747166c3"
import script from "./EditGymAscentBtn.vue?vue&type=script&lang=js"
export * from "./EditGymAscentBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports